// extracted by mini-css-extract-plugin
export default {"header":"styles_header__NICUS","logo":"styles_logo__ExwPM","skipButton":"styles_skipButton__Z6J82"};